import React from 'react';
export const HeaderWeb = ({ content }) => {
	return (
		<div className='flex z-50 w-full h-16  bg-white drop-shadow-md  md:py-1 md:pl-1 md:pr-[24px]   lg:py-1 lg:pl-1 lg:pr-[24px] xl:py-1 xl:pl-1 xl:pr-[24px] 2xl:py-1 2xl:pl-1 2xl:pr-[24px]'>
			{content}
		</div>
	);
};
